module.exports = __webpack_public_path__ + "static/media/03.014ae6f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/03.jpg
// module id = 264
// module chunks = 0